import { useCallback, useMemo, useState } from "react";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useBackOrNavigate } from "../../../../common/utils/navigateUtils";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { DashboardEPIInfo } from "../../domain/models/dashboard_epi_info";


export const usePrincipalGestaoEPIViewModel = () => {
  const {
    commons: { getAllListagemDocUseCase, getGedArquivoDataUseCase },

    gestaoEpi: { getDashboardEPIInfoUseCase },
  } = useDependencyInjection();

  const backOrNavigate = useBackOrNavigate();

  const { pushErrorNotification } = usePageLoader();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const [dashboardEPIInformation, setDashboardEPIInformation] = useState<DashboardEPIInfo>();

  const cardIds = useMemo(() => {
    return {
      nEPIEntregues: 1,
      assinaturasPendentes: 2,
    };
  }, []);

  //#region CARREGAMENTO

  const loadDashboardEPIInfo = useCallback(async (ano?: number) => {
    try {
      setLoading(true);
      const response = await getDashboardEPIInfoUseCase.execute();
      setDashboardEPIInformation(response);
    } catch (e: unknown) {
      setDashboardEPIInformation(undefined);
      throw e;
    } finally {
      setLoading(false);
    }
  }, [getDashboardEPIInfoUseCase]);

  //#endregion

  /**
   * useEffect
   */

  usePageStartBootstrap(async () => {
    try {
      await Promise.all([loadDashboardEPIInfo()]);
    } catch (e: unknown) {
      setErrorMessage(processError(e, "Falha ao carregar os dados!")[0]);
    }
  });

  /**
   * Eventos
   */

  const handleReload = useCallback(() => {
    try {
      setLoading(true);
      //    await loadDashboardEPIInfo(),
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao recarregar os dados!"),
      );
    } finally {
      setLoading(false);
    }
  }, [pushErrorNotification]);

  const handleCardClick = useCallback(
    (cardId: number) => {
      switch (cardId) {
        case cardIds.assinaturasPendentes:
          backOrNavigate("/Distribuicao_epi");
          break;
        case cardIds.nEPIEntregues:
          backOrNavigate("/Distribuicao_epi");
          break;
        
      }
    },
    [cardIds, backOrNavigate],
  );


  return {
    loading,
    errorMessage,
    dashboardEPIInformation: dashboardEPIInformation ?? null,
    cardIds,
    handleReload,
    handleCardClick,
  };
};

